/**
 * Created by forbiz on 2021-01-06.
 */

const eventRoulette = () => {

    const roulette_banner = () => {
        hdFn.hdSlide('.roulette__banner', {
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 500
        });

        if ( $('.roulette__banner').find('.swiper-slide').length <= 1 ) { $('.roulette__banner').find("[class^='swiper-button']").hide(); }
    };


    const eventRoulette_init = () => {
    	//roulette_banner();
    };

    eventRoulette_init();

    window.roulette_banner = roulette_banner;
};

export default eventRoulette;